import React from 'react';
import { trackAddToCart } from '../../utils/pixel';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  isCheckout?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  fullWidth = false,
  isCheckout = false,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-all duration-200 transform active:scale-95 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variants = {
    primary: 'bg-coral-500 hover:bg-coral-600 text-white shadow-lg hover:shadow-xl rounded-full',
    secondary: 'bg-sage-500 hover:bg-sage-600 text-white shadow-md rounded-full',
    outline: 'border-2 border-coral-500 text-coral-600 hover:bg-coral-50 rounded-full'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isCheckout) {
      // Fire pixel event
      trackAddToCart();
      // Open Hotmart in new tab
      window.open('https://pay.hotmart.com/O104555093I', '_blank');
    } else {
      // Scroll to checkout section
      const checkoutSection = document.getElementById('checkout');
      if (checkoutSection) {
        checkoutSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    if (onClick) onClick(e);
  };
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={handleClick} {...props} data-id="element-191">
      {children}
    </button>;
}